import { createSlice } from "@reduxjs/toolkit";
import { submitFlags } from "../../activityAsyncAction";
import logTypes from "../logTypes";

const initialState = {
  isAudioRecording: false,
  isVoiceDetected: false,
  isEnvNoiseDetected: false,
  recordedLongSound: 0,
  longSoundTimeInSecs: 30, //long or max audio time
  longSoundCounter: 0, // counter to update recordedLongSound
  lagTimeInSecs: 3,
  audioLog: {},
  vadOptions: {
    fftSize: 512,
    bufferLen: 512,
    smoothingTimeConstant: 0.2,
    minCaptureFreq: 85, // in Hz
    maxCaptureFreq: 255, // in Hz
    noiseCaptureDuration: 1000, // in ms
    minNoiseLevel: 0.6, // from 0 to 1
    maxNoiseLevel: 0.9, // from 0 to 1
    avgNoiseMultiplier: 1.2,
    minSegmentLengthMS: 500,
    maxCaptureSeconds: 60,
    sampleRate: 48000,
  },
};

export const audioSlice = createSlice({
  name: "audio",
  initialState,
  reducers: {
    startRecording: (state) => {
      state.isAudioRecording = true;
    },
    stopRecording: (state) => {
      state.isAudioRecording = false;
    },
    addAudioLog: (state, action) => {
      state.audioLog[action.payload.id] = action.payload;
    },
    updateVoiceDetection: (state, action) => {
      state.isVoiceDetected = action.payload;
    },
    updatEnvNoiseDetection: (state, action) => {
      state.isEnvNoiseDetected = action.payload;
    },
    longSoundCounting: (state) => {
      const {
        recordedLongSound,
        longSoundCounter,
        longSoundTimeInSecs,
        isAudioRecording,
      } = state;
      if (isAudioRecording) {
        if (longSoundCounter === longSoundTimeInSecs) {
          state.recordedLongSound = recordedLongSound + 1;
          state.longSoundCounter = 0;
          state.isAudioRecording = false;
        } else {
          state.longSoundCounter = longSoundCounter + 1;
        }
      } else {
        state.longSoundCounter = 0;
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(submitFlags.fulfilled, (state, action) => {
      const { id, logType, dataUrl } = action.payload;
      if (logType === logTypes.SOUND_DETECTED && state.audioLog[id]) {
        state.audioLog[id].saved = true;
        state.audioLog[id].dataUrl = URL.revokeObjectURL(
          state.audioLog[id].dataUrl
        );
      }
    });
    // Add reducers for additional action types here, and handle loading state as needed
    // builder.addCase(fetchUserById.fulfilled, (state, action) => {
    //   // Add user to the state array
    //   state.entities.push(action.payload)
    // })
  },
});

// Action creators are generated for each case reducer function
export const {
  startRecording,
  stopRecording,
  addAudioLog,
  longSoundCounting,
  updateVoiceDetection,
  updatEnvNoiseDetection,
} = audioSlice.actions;

export default audioSlice.reducer;
